document.addEventListener("DOMContentLoaded", () => {
  const cols = document.querySelectorAll(".spro-col");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
        // Stagger effect by index
        entry.target.style.transitionDelay = `${i * 150}ms`;
        observer.unobserve(entry.target); // animate once
      }
    });
  }, { threshold: 0.2 });

  cols.forEach(col => observer.observe(col));
});